import type { MotifComponent, MotifComponentProps } from '../../motif';
import { m } from '../../motif';
import { contrastBlackCarouselVars, defaultCardColors, widthVars } from './CarouselV3.palette';

export const snapCarouselV3PrimaryVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  ...widthVars,
  ...defaultCardColors,
  '--carousel-active-dot-color': m('--neutral-v700'),
  '--carousel-card-border-radius': '0',
  '--carousel-card-box-shadow': 'none',
  '--carousel-card-hover-box-shadow': 'none',
  '--carousel-card-desktop-grid-gap': '32px',
  '--carousel-card-mobile-grid-gap': '16px',
  '--carousel-card-border-color': 'transparent',
  '--carousel-card-hover-border-color': 'transparent',
  '--carousel-card-bg-color': 'transparent',
  '--carousel-card-hover-bg-color': 'transparent',
  '--carousel-inactive-dot-color': 'rgba(133, 141, 148, 0.50)',
  '--carousel-card-desktop-text-padding': `${m('--spacing-m')} 0`,
  '--carousel-card-mobile-text-padding': `${m('--spacing-m')} 0`,
  '--carousel-card-border-width': '0px',
  '--carousel-card-related-content-body-line-clamp': '2',
  '--carousel-card-desktop-text-height': 'auto',
  '--carousel-card-desktop-text-min-height': '0px',
  '--carousel-card-mobile-text-height': 'auto',
  '--carousel-card-mobile-text-min-height': '0px',
  '--carousel-card-text-position': 'relative',
} as const;

export const snapCarouselV3SecondaryVars: MotifComponentProps<MotifComponent.CAROUSEL> = {
  ...widthVars,
  ...contrastBlackCarouselVars,
  '--carousel-active-dot-color': m('--neutral-v0'),
  '--carousel-card-border-radius': '0',
  '--carousel-card-box-shadow': 'none',
  '--carousel-card-hover-box-shadow': 'none',
  '--carousel-card-desktop-grid-gap': '32px',
  '--carousel-card-mobile-grid-gap': '16px',
  '--carousel-card-border-color': 'transparent',
  '--carousel-card-hover-border-color': 'transparent',
  '--carousel-card-bg-color': 'transparent',
  '--carousel-card-hover-bg-color': 'transparent',
  '--carousel-inactive-dot-color': 'rgba(133, 141, 148, 0.50)',
  '--carousel-card-desktop-text-height': 'auto',
  '--carousel-card-desktop-text-min-height': '0px',
  '--carousel-card-mobile-text-height': 'auto',
  '--carousel-card-mobile-text-min-height': '0px',
  '--carousel-card-desktop-text-padding': `${m('--spacing-m')} 0`,
  '--carousel-card-mobile-text-padding': `${m('--spacing-m')} 0`,
  '--carousel-card-border-width': '0px',
  '--carousel-card-text-position': 'relative',
} as const;
